import { getListServerSideProps } from "@backend/airdrop";
import List, { seoByType } from "@organisms/airdrop/list";

export default function Airdrop(props) {
  return <List {...props} />;
}

export async function getServerSideProps(context) {
  const { query } = context;
  const { type } = query;

  if (!seoByType[type]) return { notFound: true };

  return getListServerSideProps(context, { coins: true });
}
